/**
 * The main Purpose on the file is the <withdrawalAmountRules> computed
 */
import { mapGetters } from 'vuex'
import amountDecimalRule from './amount-decimal-rule'
export default {
    mixins: [amountDecimalRule],
    computed: {
        ...mapGetters({
            getMinMaxWithdrawalByCurrency:
                'finance/getMinMaxWithdrawalByCurrency',
        }),
        playerCurrencyCookie() {
            return this.$cookie.get('player')?.currency
        },
        withdrawalMinAndMaxAmount() {
            return {
                min: this.getMinMaxWithdrawalByCurrency(
                    this.playerCurrencyCookie
                ).withdraw_min,
                max: this.getMinMaxWithdrawalByCurrency(
                    this.playerCurrencyCookie
                ).withdraw_max,
            }
        },
        withdrawalAmountRules() {
            return [
                (v) => !!v || `${this.tl('amount')} ${this.tl('isRequired')}`,
                (v) =>
                    v?.toString()?.replace(/,/g, '') > 0 ||
                    `${this.tl('amount')} ${this.tl('greaterThanZero')}`,
            ]
        },
        withdrawalAmountErrorMessages() {
            const amount = parseFloat(this.form?.amount?.replaceAll(',', ''))
            if (!amount) {
                return null
            }
            if (amount > this.playerRealtimeBalance()) {
                return `${this.tl('balanceInsufficient')}`
            }
            if (amount < this.withdrawalMinAndMaxAmount.min) {
                return `${this.tl('minimumWithdrawIs')} ${this.formatCurrencyJS(
                    this.withdrawalMinAndMaxAmount.min
                )}`
            }
            if (amount > this.withdrawalMinAndMaxAmount.max) {
                return `${this.tl('maximumWithdrawIs')} ${this.formatCurrencyJS(
                    this.withdrawalMinAndMaxAmount.max
                )}`
            }
            if (!this.decimalRule(this.form.amount?.replaceAll(',', ''))) {
                return this.tl('decimalIsTwoDigit')
            }
        },
        // This computed needs to be changed later
        withdrawalAmountErrorMessagesWithdrawalForm() {
            const amount = parseFloat(
                this.withdrawalForm?.amount?.replaceAll(',', '')
            )
            if (!amount) {
                return null
            }
            if (amount > this.playerRealtimeBalance()) {
                return `${this.tl('balanceInsufficient')}`
            }
            if (amount < this.withdrawalMinAndMaxAmount.min) {
                return `${this.tl('minimumWithdrawIs')} ${this.formatCurrencyJS(
                    this.withdrawalMinAndMaxAmount.min
                )}`
            }
            if (amount > this.withdrawalMinAndMaxAmount.max) {
                return `${this.tl('maximumWithdrawIs')} ${this.formatCurrencyJS(
                    this.withdrawalMinAndMaxAmount.max
                )}`
            }
            if (
                !this.decimalRule(
                    this.withdrawalForm?.amount?.replaceAll(',', '')
                )
            ) {
                return this.tl('decimalIsTwoDigit')
            }
        },
    },
}
